import { Module } from "vuex";
import {
    IActions,
    IGetters,
    IMutations,
    IAllProductState,
} from "./allProduct.type";

const getters: IGetters = {};

export const mutations: IMutations = {
    setL1: (state, payload) => {
        state.L1 = payload;
        state.L2 = null;
        state.L3 = null;
        state.nextIndex = 0;
        state.list = [];
    },
    setL2: (state, payload) => {
        state.L2 = payload;
        state.L3 = null;
        state.nextIndex = 0;
        state.list = [];
    },
    setL3: (state, payload) => {
        state.L3 = payload;
        state.nextIndex = 0;
        state.list = [];
    },
    setNextIndex: (state, payload) => {
        state.nextIndex = payload;
    },
    addToList: (state, payload) => {
        state.list = state.list.concat(payload);
    },
    clearList: (state) => {
        state.list = [];
    },
    reset: (state) => {
        state.nextIndex = 0;
        state.list = [];
    },
};

const actions: IActions = {
    loadMore(this, context, payload): void {
        if (context.state.nextIndex < 0) {
            return;
        }

        const branchCode = parseInt(
            (context.rootState as any)["branch"].branch.code
        );
        console.log(this, context);

        if (context.state.L1) {
            const cat = this.$services.catalog.rootCategory?.subCategory?.get(
                context.state.L1!
            );
            console.log(cat);

            if (context.state.L2) {
                const subcat = cat?.subCategory?.get(context.state.L2);
                console.log(subcat);

                if (context.state.L3) {
                    const subsubcat = subcat?.subCategory?.get(
                        context.state.L3
                    );
                    console.log(subsubcat);

                    if (subsubcat) {
                        const ps = subsubcat.productList.slice(
                            context.state.nextIndex,
                            context.state.nextIndex + 10
                        );
                        console.log(ps);

                        const productList = [];

                        for (let i = 0; i < ps.length; i++) {
                            const cprcode = ps[i];
                            if (this.$services.catalog.productMap) {
                                const product =
                                    this.$services.catalog.productMap.get(
                                        cprcode
                                    );
                                if (product) {
                                    if (product.isValidAtBranch(branchCode)) {
                                        productList.push(product);
                                    }
                                }
                            }
                        }

                        context.commit("addToList", productList);

                        if (
                            context.state.nextIndex + ps.length >=
                            subsubcat.productList.length
                        ) {
                            context.commit("setNextIndex", -1);
                        } else {
                            context.commit(
                                "setNextIndex",
                                context.state.nextIndex + ps.length
                            );
                        }
                    }
                    return;
                }

                if (subcat) {
                    const ps = subcat.productList.slice(
                        context.state.nextIndex,
                        context.state.nextIndex + 10
                    );
                    console.log(ps);

                    const productList = [];

                    for (let i = 0; i < ps.length; i++) {
                        const cprcode = ps[i];
                        if (this.$services.catalog.productMap) {
                            const product =
                                this.$services.catalog.productMap.get(cprcode);
                            if (product) {
                                if (product.isValidAtBranch(branchCode)) {
                                    productList.push(product);
                                }
                            }
                        }
                    }

                    context.commit("addToList", productList);

                    if (
                        context.state.nextIndex + ps.length >=
                        subcat.productList.length
                    ) {
                        context.commit("setNextIndex", -1);
                    } else {
                        context.commit(
                            "setNextIndex",
                            context.state.nextIndex + ps.length
                        );
                    }
                }
            }
        }
    },
};

const allProduct: Module<IAllProductState, IAllProductState> = {
    namespaced: true,
    state: {
        L1: null,
        L2: null,
        L3: null,
        nextIndex: 0,
        list: [],
    },
    getters,
    mutations,
    actions,
};

export default allProduct;
